import { ServiceObject } from "@/types/parlor";
import { GOI_PHONE } from "@/constants/contact";

const EXTRA_SERVICES = [
  "제단장식",
  "염습 · 입관",
  "수시 · 초염",
  "운구차량",
  "도우미 · 접객",
  "영정 사진",
  "헌화용 꽃",
  "음료 · 주류",
  "주차비 · 청소비",
  "근조화환 발송",
];

interface ParlorServicesGridProps {
  companyName: string;
  services: ServiceObject;
}

export const ParlorServicesGrid = ({
  companyName,
  services,
}: ParlorServicesGridProps) => {
  const serviceKeys = Object.keys(services);
  const allServices = [...new Set([...serviceKeys, ...EXTRA_SERVICES])];

  return (
    <section
      className="pd-section"
      id="pd-services"
      aria-labelledby="pd-svc-title"
    >
      <header className="pd-section__head">
        <div className="pd-section__title-block">
          <span className="pd-section__eyebrow">서비스 항목</span>
          <h2 id="pd-svc-title">제공 서비스 및 가격</h2>
          <p className="pd-section__desc">
            {companyName} 장례 시 일반적으로 이용하시게 되는 개별 항목입니다.
            항목별 단가와 장례 패키지 견적은 고이장례연구소 상담을 통해 자세히
            안내드립니다.
          </p>
        </div>
      </header>

      <div className="pd-svc-grid">
        {allServices.map((name) => (
          <div className="pd-svc-item" key={name}>
            <span className="pd-svc-item__name">{name}</span>
          </div>
        ))}
      </div>

      <p className="pd-svc-note">
        자세한 비용 견적이 필요하신 경우 <b>{GOI_PHONE} 고이장례연구소 상담</b>
        으로 문의해 주시면,
        {companyName} 기준 견적과 인근 장례식장 비교 견적을 함께 안내해
        드립니다.
      </p>
    </section>
  );
};
